// extracted by mini-css-extract-plugin
export default {"topText":"SubscriptionCanceledModal_topText__gGJJH"};